import { db } from '@/mocks/db';

import type { PaySlipSearchParams } from '../-zod-schema';

export async function findJpPaySlipIdForPeriod(
  period: string,
): Promise<string | null> {
  const slips = await db.paySlips.where('period').equals(period).toArray();
  const jp = slips.find((s) => s.countryCode === 'JP');
  return jp?.id ?? null;
}

/** 従業員に紐づく最新の給与サマリ月（YYYY-MM の降順先頭） */
export async function getEmployeeLatestPaySlipPeriodFromDb(
  employeeId: string,
): Promise<{ year: number; month: number } | null> {
  const summaries = await db.employeePaySlipSummaries
    .where('employeeId')
    .equals(employeeId)
    .toArray();
  if (summaries.length === 0) return null;
  const sorted = [...summaries].sort((a, b) =>
    b.period.localeCompare(a.period),
  );
  const [y, m] = sorted[0].period.split('-').map(Number);
  return { year: y, month: m };
}

export const getPaySlips = async (params: PaySlipSearchParams) => {
  const period = `${params.year}-${String(params.month).padStart(2, '0')}`;
  let items = await db.employeePaySlipSummaries
    .where('period')
    .equals(period)
    .toArray();

  if (params.freeText) {
    const q = params.freeText.toLowerCase();
    items = items.filter(
      (s) =>
        s.employeeName.toLowerCase().includes(q) ||
        s.email.toLowerCase().includes(q),
    );
  }

  const total = items.length;
  const paged = items.slice(
    params.pageIndex * params.pageSize,
    (params.pageIndex + 1) * params.pageSize,
  );

  return { items: paged, total, maxPage: Math.ceil(total / params.pageSize) };
};
